@if (initializing) {
  <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-py-6">
    <span class="vk-oauth-spinner !tw-size-5" [attr.aria-label]="'loading' | i18n"></span>
  </div>
} @else {
  @if (userType === SetInitialPasswordUserType.OFFBOARDED_TDE_ORG_USER_UNTRUSTED_DEVICE) {
    <div class="tw-mt-4"></div>
    <bit-callout type="warning">
      {{ "loginOnTrustedDeviceOrAskAdminToAssignPassword" | i18n }}
    </bit-callout>
    <button
      type="button"
      bitButton
      block
      buttonType="subtleGhost"
      class="!tw-text-[var(--vk-muted)] hover:!tw-text-[var(--vk-ink)]"
      (click)="logout()"
    >
      {{ "logOut" | i18n }}
    </button>
  } @else {
    @if (email) {
      <div
        class="tw-mb-4 tw-flex tw-items-center tw-justify-center"
        data-testid="initial-password-account-email"
      >
        <span
          class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-border tw-border-solid tw-border-[var(--vk-line)] tw-bg-[var(--vk-paper)] tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-[var(--vk-muted)]"
        >
          <span class="tw-size-1.5 tw-rounded-full tw-bg-[var(--vk-green)]" aria-hidden="true"></span>
          {{ email }}
        </span>
      </div>
    }

    <bit-callout
      *ngIf="resetPasswordAutoEnroll"
      type="warning"
      title="{{ 'resetPasswordPolicyAutoEnroll' | i18n }}"
    >
      {{ "resetPasswordAutoEnrollInviteWarning" | i18n }}
    </bit-callout>

    <auth-input-password
      [flow]="inputPasswordFlow"
      [email]="email"
      [userId]="userId"
      [loading]="submitting"
      [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
      [primaryButtonText]="{
        key:
          userType === SetInitialPasswordUserType.OFFBOARDED_TDE_ORG_USER
            ? 'setPassword'
            : 'createAccount',
      }"
      [secondaryButtonText]="{ key: 'logOut' }"
      (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
      (onSecondaryButtonClick)="logout()"
    ></auth-input-password>
  }
}
